import { ITextBlock } from "src/components/Typography/types";
import { cookiePolicyTrns } from "./trns";

const INTRODUCTION_BLOCK: ITextBlock = {
  id: "1",
  title: {
    i18nKey: cookiePolicyTrns.introductionTitle,
    i18nParams: { count: "1" },
  },
  intro: { i18nKey: cookiePolicyTrns.introductionContent },
  textSubBlocks: [
    {
      id: "1.1",
      subheading: { i18nKey: cookiePolicyTrns.purposeTitle },
      text: { i18nKey: cookiePolicyTrns.purposeContent },
    },
    {
      id: "1.2",
      subheading: { i18nKey: cookiePolicyTrns.whatCookiesTitle },
      text: { i18nKey: cookiePolicyTrns.whatCookiesContent },
    },
    {
      id: "1.3",
      subheading: { i18nKey: cookiePolicyTrns.cookiesImproveTitle },
      text: { i18nKey: cookiePolicyTrns.cookiesImproveContent },
    },
    {
      id: "1.4",
      subheading: { i18nKey: cookiePolicyTrns.cookiesImportanceTitle },
      text: { i18nKey: cookiePolicyTrns.cookiesImportanceContent },
    },
    {
      id: "1.5",
      subheading: { i18nKey: cookiePolicyTrns.consentTitle },
      text: { i18nKey: cookiePolicyTrns.consentContent },
    },
    {
      id: "1.6",
      subheading: { i18nKey: cookiePolicyTrns.conclusionTitle },
      text: { i18nKey: cookiePolicyTrns.conclusionContent },
    },
  ],
};

const USAGE_BLOCK: ITextBlock = {
  id: "2",
  title: {
    i18nKey: cookiePolicyTrns.cookiesUsageTitle,
    i18nParams: { count: "2" },
  },
  intro: { i18nKey: cookiePolicyTrns.cookiesUsageContent },
  textSubBlocks: [
    {
      id: "2.1",
      subheading: { i18nKey: cookiePolicyTrns.ensureFunctionalityTitle },
      text: { i18nKey: cookiePolicyTrns.ensureFunctionalityContent },
    },
    {
      id: "2.2",
      subheading: { i18nKey: cookiePolicyTrns.improvePerformanceTitle },
      text: { i18nKey: cookiePolicyTrns.improvePerformanceContent },
    },
    {
      id: "2.3",
      subheading: { i18nKey: cookiePolicyTrns.personalizationTitle },
      text: { i18nKey: cookiePolicyTrns.personalizationContent },
    },
    {
      id: "2.4",
      subheading: { i18nKey: cookiePolicyTrns.trafficAnalysisTitle },
      text: { i18nKey: cookiePolicyTrns.trafficAnalysisContent },
    },
    {
      id: "2.5",
      subheading: { i18nKey: cookiePolicyTrns.trafficAnalysisTitle },
      text: { i18nKey: cookiePolicyTrns.trafficAnalysisContent },
    },
    {
      id: "2.6",
      subheading: { i18nKey: cookiePolicyTrns.advertisingTitle },
      text: { i18nKey: cookiePolicyTrns.advertisingContent },
    },
  ],
};

const MANAGING_COOKIES_BLOCK: ITextBlock = {
  id: "3",
  title: {
    i18nKey: cookiePolicyTrns.manageCookiesTitle,
    i18nParams: { count: "3" },
  },
  intro: { i18nKey: cookiePolicyTrns.manageCookiesContent },
  textSubBlocks: [
    {
      id: "3.1",
      subheading: { i18nKey: cookiePolicyTrns.importantNotesTitle },
      text: { i18nKey: cookiePolicyTrns.importantNotesContent },
    },
    {
      id: "3.2",
      subheading: { i18nKey: cookiePolicyTrns.alternativeMethodsTitle },
      text: { i18nKey: cookiePolicyTrns.alternativeMethodsContent },
    },
  ],
};

const MANAGING_TOOLS_BLOCK: ITextBlock = {
  id: "4",
  title: {
    i18nKey: cookiePolicyTrns.toolsAndResourcesTitle,
    i18nParams: { count: "4" },
  },
  textSubBlocks: [
    {
      id: "4.1",
      text: { i18nKey: cookiePolicyTrns.toolsAndResourcesContent },
    },
  ],
};
const POLICY_CHANGES_TOOLS_BLOCK: ITextBlock = {
  id: "5",
  title: {
    i18nKey: cookiePolicyTrns.policyChangesTitle,
    i18nParams: { count: "5" },
  },
  intro: { i18nKey: cookiePolicyTrns.policyChangesContent },
  textSubBlocks: [
    {
      id: "5.1",
      subheading: { i18nKey: cookiePolicyTrns.publishingChangesTitle },
      text: { i18nKey: cookiePolicyTrns.publishingChangesContent },
    },
    {
      id: "5.2",
      subheading: { i18nKey: cookiePolicyTrns.typesOfChangesTitle },
      text: { i18nKey: cookiePolicyTrns.typesOfChangesContent },
    },
    {
      id: "5.3",
      subheading: { i18nKey: cookiePolicyTrns.stayInformedTitle },
      text: { i18nKey: cookiePolicyTrns.stayInformedContent },
    },
    {
      id: "5.4",
      subheading: { i18nKey: cookiePolicyTrns.contactInfoTitle },
      text: { i18nKey: cookiePolicyTrns.contactInfoContent },
    },
  ],
};

export const COOKIE_POLICY_BLOCKS = [
  INTRODUCTION_BLOCK,
  USAGE_BLOCK,
  MANAGING_COOKIES_BLOCK,
  MANAGING_TOOLS_BLOCK,
  POLICY_CHANGES_TOOLS_BLOCK,
];
